export default "__VITE_ASSET__Bou$Zjmr__"